import InstitutionCompanyForm from '@/features/institution/company/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingCompanyPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="company" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionCompanyForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingCompanyPage.displayName = 'InstitutionOnboardingCompanyPage';

export default InstitutionOnboardingCompanyPage;
